import { CreatorFunctions } from "@microchip/melody-automodule-interface";
import {
    getCreatorFunctions as getCreatorFunctionsUser,
    getModuleConfigFromFile,
} from "./getUserData";

const createAutoCreator = (
    getCreatorFunctions: () => CreatorFunctions,
): (() => CreatorFunctions) => {
    return (): CreatorFunctions => {
        return {
            getModuleConfig: getModuleConfigFromFile,
            ...getCreatorFunctions(),
        };
    };
};

export const getCreatorFunctions = createAutoCreator(getCreatorFunctionsUser);
